import { LayoutRenderLayoutItemOptions } from '../../../models/cv-layout-render.model';

export enum RoomRulesDesign {
	INLINE = 'inline',
	FULL_WIDTH = 'full-width'
}

export class InlineRulesOptions extends LayoutRenderLayoutItemOptions {
	layout?: string;
	filter?: any;
	appendPathToTarget?: boolean;

	constructor() {
		super();
		this.layout = RoomRulesDesign.INLINE;
		this.appendPathToTarget = true;
	}
}